export default "__VITE_ASSET__DthtFRo5__"